import React, { useEffect, useState } from 'react';
import { Select, Space, Button, Checkbox, TreeSelect, Tooltip, Typography, Flex, Input, Modal, Upload, message } from 'antd';
import Table from 'react-bootstrap/Table';
import { Form, Container, Row, Col } from 'react-bootstrap';
import { FcCancel } from "react-icons/fc";
import { TiTick } from "react-icons/ti";
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { FcInfo } from "react-icons/fc";
import { BsCart4 } from "react-icons/bs";
import { IoArrowBackCircle } from "react-icons/io5";
import { UploadOutlined, FileTextOutlined, FileWordOutlined, FilePdfOutlined, FileExcelOutlined, FileImageOutlined, FileUnknownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import axios from "axios";
import Swal from 'sweetalert2';
import Loader from '../Reusable/loader';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { BASE_URL } from "../../App";
import { Backdrop, CircularProgress } from '@mui/material';
import { IconButton, Box } from '@mui/material';

const { Search } = Input;
const { Dragger } = Upload;
const Order3 = ({ 
  onPrev, 
  selectedOption, 
  orderType, 
  anyLocationChecked, 
  onNext, 
  selectedData, 
  uploadedDocuments
}) => {
  
  const [selectedItems, setSelectedItems] = useState(selectedData || []);
  const [searchValue, setSearchValue] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [rows, setRows] = useState([]);
  const [disableAddItem, setDisableAddItem] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [items, setItems] = useState([]);
  const [addedItemIds, setAddedItemIds] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [filteredValue, setFilteredValue] = useState([]);
  const [filteredLabel, setFilteredLabel] = useState([]);
  const [checked, setChecked] = useState(false);
  const [checkedValue, setCheckedValue] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [addedItems, setAddedItems] = useState(selectedData || []);
  const [tooltipTitle, setTooltipTitle] = useState('');
  const [realTimeinfo, setRealTimeinfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [bcsUploadModalVisible, setBcsUploadModalVisible] = useState(false);
  const [currentBcsItem, setCurrentBcsItem] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
const [previewFile, setPreviewFile] = useState(null);
const [previewTitle, setPreviewTitle] = useState('');
const handlePreview = async (file, title) => {
  if (!file) return;
  
  setPreviewFile(file);
  setPreviewTitle(title);
  setPreviewVisible(true);
};

const handlePreviewCancel = () => {
  setPreviewVisible(false);
};

  const [uploadedFiles, setUploadedFiles] = useState({});
  // const [uploadedFiles, setUploadedFiles] = useState({
  //   workOrder: null,
  //   technicalDataSheet: null,
  //   customerApprovedGAD: null,
  //   customerApprovedQAP: null,
  //   drawings: null,
  //   otherDocuments: null
  // });
  const [bcsItemsWithoutDocs, setBcsItemsWithoutDocs] = useState([]);
  const [bcsItemsWithDocs, setBcsItemsWithDocs] = useState({}); 

  const login_id = localStorage.getItem("LOGIN_ID");
  const branch = localStorage.getItem("BRANCH_CODE");
  const [uploadedFilesData, setUploadedFilesData] = useState({});

  useEffect(() => {
    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("MATSUBGROUP_CODE", filteredValue);
    formData.append("FORMNAME", orderType);
    formData.append("CHKFASTMOVING", checkedValue);
    formData.append("ITEMSEARCHSTRING", searchValue);
    formData.append("OFFSET", "0");
    formData.append("NEXT", "20");

    axios.post(BASE_URL + "/getitemcode", formData)
      .then((response) => {
        setIsLoading(false);
        setItems(response.data.ITEMCODE);
        console.log(' first Api ', response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });

    const formData1 = new FormData();
    formData1.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData1.append("MATSUBGROUP_CODE", filteredValue);
    formData1.append("FORMNAME", orderType);
    formData1.append('login_id', login_id);
    formData1.append("CHKFASTMOVING", checkedValue);
    formData1.append("ITEMSEARCHSTRING", searchValue);
    formData1.append("OFFSET", "0");
    formData1.append("NEXT", "20");

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: BASE_URL + "/getmatgroup",
      data: formData1
    };

    axios.request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data.DEALER_PSG));
        setFiltered(response.data.DEALER_PSG);
      })
      .catch((error) => {
        console.log(error);
      });

    const formData2 = new FormData();
    formData2.append('login_id', login_id);
    formData2.append('type', 'order');
    formData2.append('dealer_code', selectedOption.values.DEALER_CODE);

    const config1 = {
      method: 'post',
      maxBodyLength: Infinity,
      url: BASE_URL + "/getrealtimeinfoordering",
      data: formData2
    };

    axios.request(config1)
      .then((response) => {
        setRealTimeinfo(response.data.dealer_details[0]);
        console.log('real time info', response.data.dealer_details[0]);
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log('real time', error);
      });
  }, []);

  // const handleNext = async () => {
  //   setLoading(true);
  //   if (anyLocationChecked === 1) {
  //     const result = await validateGroupedTotals(totalsByBGAndUnit, orderType);
  //     if (result.status === 'error') {
  //       setLoading(false);
  //       return;
  //     }
  //   }

  //   console.log('select data  1 page', selectedItems);
  //   console.log('select data  1 page', invoiceSubtotal);
  //   console.log('select data  1 page', qty);
  //   console.log('select data  1 page', invoiceTotal);
  //   setAddedItems(prevAddedItems => [...prevAddedItems, selectedItems.MAT_CODE]);
  //   var gotonext = '1';

  //   const invoiceTaxtotalqty = selectedItems.reduce((sum, row) => {
  //     const rowTaxQty = row.qty;
  //     const rowMATCODE = row.MAT_CODE;

  //     if (rowTaxQty == '') {
  //       gotonext = '0';
  //       Swal.fire({
  //         title: '',
  //         text: 'Please Quantity Add',
  //         icon: 'warning',
  //         confirmButtonText: 'OK'
  //       });
  //       setLoading(false);
  //       return false;
  //     } else {
  //       setLoading(false);
  //     }
  //   }, 0);

  //   if (selectedItems && invoiceSubtotal && typeof qty !== 'undefined' && qty !== '' && invoiceTotal) {
  //     setLoading(false);
  //   } else {
  //     Swal.fire({
  //       title: '',
  //       text: 'Please add items before proceeding to the next step!',
  //       icon: 'warning',
  //       confirmButtonText: 'OK'
  //     });
  //     setLoading(false);
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);

  //   const itemCodes = [];
  //   const quantities = [];

  //   if (Array.isArray(selectedItems) && selectedItems.length > 0) {
  //     selectedItems.forEach(row => {
  //       itemCodes.push(row.MAT_CODE);
  //       quantities.push(row.qty.toString());
  //     });

  //     formData.append("item_code", itemCodes);
  //     formData.append("item_qty", quantities);
  //   }

  //   let gotonextapi = '1';

  //   try {
  //     const response = await axios.post(BASE_URL + "/getQtyvalue", formData);
  //     setLoading(false);
  //     console.log("Response from API:", response.data);
  //   } catch (error) {
  //     gotonextapi = '0';
  //     await Swal.fire({
  //       icon: 'warning',
  //       title: error.response.data.Message,
  //     });
  //     setLoading(false);
  //     return;
  //   }

  //   if (gotonext == 1 && gotonextapi == 1) {
  //     if (selectedItems && invoiceSubtotal && typeof qty !== 'undefined' && qty !== '' && invoiceTotal) {
  //       onNext({ selectedItems, invoiceSubtotal, qty, invoiceTotal, filteredLabel, filteredValue, anyLocationChecked });
  //       setLoading(false);
  //     } else {
  //       Swal.fire({
  //         title: '',
  //         text: 'Items Is Not Selected',
  //         icon: 'warning',
  //         confirmButtonText: 'OK'
  //       });
  //       setLoading(false);
  //     }
  //   }
  // };
  const handleNext = async () => {
  setLoading(true);
  if (anyLocationChecked === 1) {
    const result = await validateGroupedTotals(totalsByBGAndUnit, orderType);
    if (result.status === 'error') {
      setLoading(false);
      return;
    }
  }

  // Check if any BCS items require documents but don't have them
  const bcsItemsWithoutRequiredDocs = selectedItems.filter(item => 
    item.bcs && item.bcs.toLowerCase() === 'bcs' && 
    !bcsItemsWithDocs[item.MAT_CODE] && 
    !bcsItemsWithoutDocs.includes(item.MAT_CODE)
  );

  if (bcsItemsWithoutRequiredDocs.length > 0) {
    setLoading(false);
    Swal.fire({
      title: 'BCS Documents Required',
      text: 'Please upload documents or confirm proceeding without documents for all BCS items before continuing.',
      icon: 'warning',
      confirmButtonText: 'OK'
    });
    return;
  }

  console.log('select data  1 page', selectedItems);
  console.log('select data  1 page', invoiceSubtotal);
  console.log('select data  1 page', qty);
  console.log('select data  1 page', invoiceTotal);
  setAddedItems(prevAddedItems => [...prevAddedItems, selectedItems.MAT_CODE]);
  var gotonext = '1';

  const invoiceTaxtotalqty = selectedItems.reduce((sum, row) => {
    const rowTaxQty = row.qty;
    const rowMATCODE = row.MAT_CODE;

    if (rowTaxQty == '') {
      gotonext = '0';
      Swal.fire({
        title: '',
        text: 'Please Quantity Add',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      setLoading(false);
      return false;
    } else {
      setLoading(false);
    }
  }, 0);

  if (selectedItems && invoiceSubtotal && typeof qty !== 'undefined' && qty !== '' && invoiceTotal) {
    setLoading(false);
  } else {
    Swal.fire({
      title: '',
      text: 'Please add items before proceeding to the next step!',
      icon: 'warning',
      confirmButtonText: 'OK'
    });
    setLoading(false);
    return;
  }

  const formData = new FormData();
  formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);

  const itemCodes = [];
  const quantities = [];

  if (Array.isArray(selectedItems) && selectedItems.length > 0) {
    selectedItems.forEach(row => {
      itemCodes.push(row.MAT_CODE);
      quantities.push(row.qty.toString());
    });

    formData.append("item_code", itemCodes);
    formData.append("item_qty", quantities);
  }

  let gotonextapi = '1';

  try {
    const response = await axios.post(BASE_URL + "/getQtyvalue", formData);
    setLoading(false);
    console.log("Response from API:", response.data);
  } catch (error) {
    gotonextapi = '0';
    await Swal.fire({
      icon: 'warning',
      title: error.response.data.Message,
    });
    setLoading(false);
    return;
  }

  if (gotonext == 1 && gotonextapi == 1) {
    if (selectedItems && invoiceSubtotal && typeof qty !== 'undefined' && qty !== '' && invoiceTotal) {
      // Pass uploaded documents data to the next page
      console.log('upload data', uploadedFilesData);
      onNext({ 
        selectedItems, 
        invoiceSubtotal, 
        qty, 
        invoiceTotal, 
        filteredLabel, 
        filteredValue, 
        anyLocationChecked,
        uploadedDocuments: uploadedFilesData 
      });
      setLoading(false);
    } else {
      Swal.fire({
        title: '',
        text: 'Items Is Not Selected',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      setLoading(false);
    }
  }
};

  const handleViewMore = (event) => {
    event.preventDefault();
    const filteredValuess = filteredValue;
    console.log('call ', filteredValuess);
    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("MATSUBGROUP_CODE", filteredValue);
    formData.append("FORMNAME", orderType);
    formData.append("CHKFASTMOVING", checkedValue);
    formData.append("ITEMSEARCHSTRING", searchValue);
    const offsets = items.length;
    const offset = offsets + 1;
    formData.append("OFFSET", offset.toString());
    formData.append("NEXT", "20");

    axios.post(BASE_URL + "/getitemcode", formData)
      .then((response) => {
        console.log("Response from API:", response.data);
        setItems(prevItems => [...prevItems, ...response.data.ITEMCODE]);
      })
      .catch((error) => {
        console.error("Error fetching more items:", error);
      });
  };

  const handleSwitchChange = () => {
    setChecked(!checked);
    const valueToDatabase = checked ? 1 : 0;
    setCheckedValue(valueToDatabase);
    console.log('check data', checkedValue);
    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("MATSUBGROUP_CODE", filteredValue);
    formData.append("FORMNAME", orderType);
    formData.append("CHKFASTMOVING", checkedValue);
    formData.append("ITEMSEARCHSTRING", searchValue);
    formData.append("OFFSET", "0");
    formData.append("NEXT", "20");

    axios.post(BASE_URL + "/getitemcode", formData)
      .then((response) => {
        setItems(response.data.ITEMCODE);
      })
      .catch((error) => {
        console.error("Error fetching more items:", error);
      });
  };

  const handleCardClick = (item) => {
    setLoading(true);

    if (selectedItems.length > 0) {
      const firstBcs = selectedItems[0].bcs;
      if (firstBcs !== item.bcs) {
        Swal.fire({
          title: 'Item Category Restricted',
          text: `You've already added a '${firstBcs.toUpperCase()}' item. Only items from the same '${firstBcs.toUpperCase()}' category can be added.`,
          icon: 'info',
          confirmButtonText: 'OK'
        });
        setLoading(false);
        return;
      }
    }

    if (!selectedItems.find(selectedItem => selectedItem.MAT_CODE === item.MAT_CODE)) {
      // For BCS items, add directly to cart without requiring documents upfront
      addItemToCart(item);
    } else {
      Swal.fire({
        title: '',
        text: 'This item is already in the selected items list.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      setLoading(false);
    }
  };

  const addItemToCart = (item) => {
    setIsButtonDisabled(true);
    setAddedItems(prevAddedItems => [...prevAddedItems, item.MAT_CODE]);
    let data = new FormData();
    data.append('item_code', item.MAT_CODE);
    data.append('item_description', item.DESCRIPTION);
    data.append('dealer_code', selectedOption.values.DEALER_CODE);
    data.append('order_type', orderType);
    data.append('p_unit', item.MUUNITCODE);
    data.append('psg', item.PSG);
    data.append('bg', item.BG);

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: BASE_URL + "/getpricestockdetails",
      data: data
    };

    axios.request(config)
      .then((response) => {
        console.log(response.data);
        const additionalDetails = response.data.itemdetails.additional_details || {};
        const rowData = {
          item_code: response.data.itemdetails.item_code,
          item_description: response.data.itemdetails.item_description,
          base_price: response.data.itemdetails.base_price,
          tax: parseFloat(response.data.itemdetails.tax),
          total: response.data.itemdetails.total,
          pending_npo: additionalDetails.pending_npo,
          pending_mpo: additionalDetails.pending_mpo,
          stock: additionalDetails.stock,
          p_unit: response.data.itemdetails.p_unit,
          psg: response.data.itemdetails.PSG,
          bg: response.data.itemdetails.BG,
          bcs: item.bcs,
        };

        console.log('zummmmmm', rowData.p_unit);
        const newItem = createRow(item.MAT_CODE, item.DESCRIPTION, 1, rowData.base_price, 0, rowData.tax, rowData.total, rowData.pending_npo, rowData.pending_mpo, rowData.stock, rowData.p_unit, rowData.psg, rowData.bg, rowData.bcs);
        setSelectedItems(prevRows => [...prevRows, newItem]);
        console.log('chchch', selectedItems);
        setDisableAddItem(true);
        setIsButtonDisabled(false);
        setSelectedItem(newItem);
        setAddedItems(prevAddedItems => [...prevAddedItems, item.MAT_CODE]);
        setLoading(false);
      })
      .catch((error) => {
        setAddedItems(prevAddedItems => prevAddedItems.filter(addedItem => addedItem !== item.MAT_CODE));
        setIsButtonDisabled(false);
        console.log('data no data', error);
        Swal.fire({
          title: 'No Data',
          text: error.response.data.message,
          icon: 'error',
          confirmButtonText: 'OK'
        });
        setLoading(false);
      });
    console.log('test ', selectedItems);
  };

  const handleBcsUploadClick = (item) => {
    setCurrentBcsItem(item);
    setBcsUploadModalVisible(true);
  };

  // const handleBcsUploadOk = () => {
  //   if (currentBcsItem) {
  //     // Mark this BCS item as having documents
  //     setBcsItemsWithDocs(prev => ({
  //       ...prev,
  //       [currentBcsItem.MAT_CODE]: true
  //     }));
  //   }
  //   setBcsUploadModalVisible(false);
  //   // Reset uploaded files for next time
  //   setUploadedFiles({
  //     workOrder: null,
  //     technicalDataSheet: null,
  //     customerApprovedGAD: null,
  //     customerApprovedQAP: null,
  //     drawings: null,
  //     otherDocuments: null
  //   });
  // };
  
// Update handleBcsUploadOk function
const handleBcsUploadOk = () => {
  if (currentBcsItem) {
    // Mark this BCS item as having documents
    setBcsItemsWithDocs(prev => ({
      ...prev,
      [currentBcsItem.MAT_CODE]: true
    }));
    
    // Store the uploaded files data for this item
    // setUploadedFilesData(prev => ({
    //   ...prev,
    //   [currentBcsItem.MAT_CODE]: uploadedFiles
    // }));

     setUploadedFilesData(uploadedFiles);

  }
  setBcsUploadModalVisible(false);
  // Reset uploaded files for next time
//  setUploadedFiles({
//    workOrder: null,
//    technicalDataSheet: null,
//    customerApprovedGAD: null,
//    customerApprovedQAP: null,
//    drawings: null,
//    otherDocuments: null
//  });
};

  const handleBcsUploadCancel = () => {
    setBcsUploadModalVisible(false);
    // Reset uploaded files for next time
    // setUploadedFiles({
    //   workOrder: null,
    //   technicalDataSheet: null,
    //   customerApprovedGAD: null,
    //   customerApprovedQAP: null,
    //   drawings: null,
    //   otherDocuments: null
    // });
  };

  const handleBcsProceedWithoutDocs = () => {
    if (currentBcsItem) {
      setBcsItemsWithoutDocs(prev => [...prev, currentBcsItem.MAT_CODE]);
    }
    setBcsUploadModalVisible(false);
    // Reset uploaded files for next time
    // setUploadedFiles({
    //   workOrder: null,
    //   technicalDataSheet: null,
    //   customerApprovedGAD: null,
    //   customerApprovedQAP: null,
    //   drawings: null,
    //   otherDocuments: null
    // });
  };

  // const handleFileUpload = (fileType, file) => {
  //   // Check file size (max 2MB)
  //   if (file.size > 2 * 1024 * 1024) {
  //     message.error(`${file.name} is too large. Maximum file size is 2MB.`);
  //     return Upload.LIST_IGNORE;
  //   }
    
  //   setUploadedFiles(prev => ({
  //     ...prev,
  //     [fileType]: file
  //   }));
  //   return false;
  // };

  // const handleFileUpload = (itemCode, fileType, file) => {

  //     if (file.size > 2 * 1024 * 1024) {
  //       message.error(`${file.name} is too large. Maximum file size is 2MB.`);
  //       return Upload.LIST_IGNORE;
  //     }

  //   setUploadedFiles((prevDocs) => ({
  //     ...prevDocs,
  //     [itemCode]: {
  //       ...prevDocs[itemCode],
  //       [fileType]: file
  //     }
  //   }));
  // };

      const handleFileUpload = (itemCode, fileType, file) => {
        // File size validation
        if (file.size > 2 * 1024 * 1024) {
          message.error(`${file.name} is too large. Maximum file size is 2MB.`);
          return Upload.LIST_IGNORE;
        }

        setUploadedFiles((prev) => {
          const existingItem = prev[itemCode] || {
            workOrder: null,
            technicalDataSheet: null,
            customerApprovedGAD: null,
            customerApprovedQAP: null,
            drawings: null,
            otherDocuments: null,
          };

          return {
            ...prev, // ✅ keep all other itemCodes
            [itemCode]: {
              ...existingItem, // ✅ keep this item’s other files
              [fileType]: file, // ✅ update only the selected fileType
            },
          };
        });
      };



  // const handleRemoveFile = (fileType) => {
  //   setUploadedFiles(prev => ({
  //     ...prev,
  //     [fileType]: null
  //   }));
  // };

  const handleRemoveFile = (itemCode, fileType) => {
      setUploadedFiles((prev) => ({
        ...prev,
        [itemCode]: {
          ...prev[itemCode],
          [fileType]: null,
        },
      }));
    };


     useEffect(() => {
  if (uploadedDocuments && Object.keys(uploadedDocuments).length > 0) {
    // const newUploadedFiles = { ...uploadedFiles };

    // console.log("Selected Data:", selectedData); // Debugging: Check selectedData
    // console.log("Uploaded Documents:", uploadedDocuments); // Debugging: Check uploadedDocuments

    // // Iterate through the selectedData
    // if (selectedData && selectedData.length > 0) {
    //   selectedData.forEach(item => {
    //     // Check if MAT_CODE exists in each item of selectedData
    //     if (item.MAT_CODE) {
    //       const matCodeFromSelected = item.MAT_CODE.trim();  // Trim the MAT_CODE from selectedData

    //       console.log("Checking MAT_CODE:", matCodeFromSelected); // Debugging: Check the MAT_CODE being processed

    //       // Iterate through the uploadedDocuments keys (dynamicKey)
    //       Object.keys(uploadedDocuments).forEach(dynamicKey => {
    //         // Trim the dynamicKey (key of uploadedDocuments) for comparison
    //         const matCodeFromData = dynamicKey.trim();

    //         console.log("Comparing with dynamicKey:", matCodeFromData); // Debugging: Check the key from uploadedDocuments

    //         // If MAT_CODEs match, update the newUploadedFiles object
    //         if (matCodeFromData === matCodeFromSelected) {
    //           const documentData = uploadedDocuments[dynamicKey];

    //           console.log("Match found for MAT_CODE:", matCodeFromSelected); // Debugging: Confirm match

    //           // Now, update newUploadedFiles with file data from documentData
    //           Object.keys(uploadedFiles).forEach((fileType) => {
    //             if (documentData && documentData[fileType]) {
    //               console.log("Updating fileType:", fileType); // Debugging: Check which fileType is being updated
    //               newUploadedFiles[fileType] = documentData[fileType];
    //             }
    //           });
    //         }
    //       });
    //     }
    //   });
    // }

    // // Set the updated uploadedFiles state
    // console.log("Updated uploadedFiles:", newUploadedFiles); // Debugging: Final state of uploadedFiles
    setUploadedFiles(uploadedDocuments);
  }
}, [uploadedDocuments]); 
 // Always call useEffect, not conditionally

// useEffect(() => {
//   if (uploadedDocuments && Object.keys(uploadedDocuments).length > 0) {
//     const newUploadedFiles = { ...uploadedFiles };

//     // Iterate through the selectedData
//     if (selectedData && selectedData.length > 0) {
//       selectedData.forEach(item => {
//         // Check if MAT_CODE exists in each item of selectedData
//         if (item.MAT_CODE) {
//           const matCodeFromSelected = item.MAT_CODE.trim();  // Trim the MAT_CODE from selectedData

//           // Iterate through the uploadedDocuments keys (dynamicKey)
//           Object.keys(uploadedDocuments).forEach(dynamicKey => {
//             // Trim the dynamicKey (key of uploadedDocuments) for comparison
//             const matCodeFromData = dynamicKey.trim(); 

//             // If MAT_CODEs match, update the newUploadedFiles object for that item
//             if (matCodeFromData === matCodeFromSelected) {
//               const documentData = uploadedDocuments[dynamicKey];

//               // Create or update an entry for the matching MAT_CODE in newUploadedFiles
//               const updatedItemFiles = {}; // For the specific MAT_CODE, hold its files

//               // Loop over the file types and add the file data for the current MAT_CODE
//               Object.keys(uploadedFiles).forEach((fileType) => {
//                 if (documentData && documentData[fileType]) {
//                   updatedItemFiles[fileType] = documentData[fileType];
//                 }
//               });

//               // Set the uploaded files for this specific MAT_CODE (matching item)
//               newUploadedFiles[matCodeFromSelected] = updatedItemFiles;
//             }
//           });
//         }
//       });
//     }

//     // After applying updates for all MAT_CODEs, set the updated uploadedFiles state
//     setUploadedFiles(newUploadedFiles);
//   }
// }, [uploadedDocuments, selectedData]);  // Always call useEffect, not conditionally

    

  // const uploadButton = (fileType, icon, title,item_code) => {

  //  console.log('upload data 2', uploadedDocuments);

  // const file = uploadedFiles[fileType];

  //  //const file = uploadedFiles[fileType];

  // console.log("File for type:", fileType, file); // Add this line to debug



  //   return (
  //     <div className="text-center mb-3">
  //       <Dragger
  //         name={fileType}
  //         multiple={false}
  //         showUploadList={false}
  //         beforeUpload={(file) => handleFileUpload(fileType, file)}
  //         accept=".txt,.doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png"
  //         className="custom-uploader"
  //       >
  //         <p className="ant-upload-drag-icon">
  //           {icon}
  //         </p>
  //         <p className="ant-upload-text">{title}</p>
  //         <p className="ant-upload-hint">
  //           Supports TXT, DOC, PDF, XLS, JPG, PNG (Max 2MB)
  //         </p>
  //       </Dragger>

  //       {file && (
  //         <div className="uploaded-file-info mt-2">
  //           <span>{file.name}</span>
  //           <Button
  //             type="link"
  //             danger
  //             onClick={() => handleRemoveFile(fileType)}
  //             size="small"
  //           >
  //             Remove
  //           </Button>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
const uploadButton = (fileType, icon, title, itemCode) => {
  const file = uploadedFiles[itemCode]?.[fileType];

  return (
    <div className="text-center mb-3">
      <Dragger
        name={fileType}
        multiple={false}
        showUploadList={false}
        beforeUpload={(file) => {
          handleFileUpload(itemCode, fileType, file);
          return false;
        }}
        accept=".txt,.doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png"
      >
        <p className="ant-upload-drag-icon">{icon}</p>
        <p className="ant-upload-text">{title}</p>
      </Dragger>

      {file && (
        <div className="uploaded-file-info mt-2">
          <span>{file.name}</span>
          <div>
            <Button
              type="link"
              size="small"
              onClick={() => handlePreview(file, title)}
              style={{ padding: '0 4px' }}
            >
              Preview
            </Button>
            <Button
              type="link"
              danger
              onClick={() => handleRemoveFile(itemCode, fileType)}
              size="small"
              style={{ padding: '0 4px' }}
            >
              Remove
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
  // const uploadButton = (fileType, icon, title,itemCode) => {

  //   console.log('data view', uploadedDocuments);

  //   const file = uploadedFiles[itemCode]?.[fileType];

  //     return (
  //       <div className="text-center mb-3">
  //         <Dragger
  //           name={fileType}
  //           multiple={false}
  //           showUploadList={false}
  //           beforeUpload={(file) => {
  //             handleFileUpload(itemCode, fileType, file);
  //             return false;
  //           }}
  //           accept=".txt,.doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png"
  //         >
  //           <p className="ant-upload-drag-icon">{icon}</p>
  //           <p className="ant-upload-text">{title}</p>
  //         </Dragger>

  //         {/* 👇 This will show once uploadedFiles updates correctly */}
  //         {file && (
  //           <div className="uploaded-file-info mt-2">
  //             <span>{file.name}</span>
  //             <Button
  //               type="link"
  //               danger
  //               onClick={() => handleRemoveFile(itemCode, fileType)}
  //               size="small"
  //             >
  //               Remove
  //             </Button>
  //           </div>
  //         )}
  //       </div>
  //     );
  //   };


  const handelFilterChange = (value, option) => {
    console.log(`selected ${value}`);
    console.log(`selected ${option.label}`);
    const fildervalue = value;
    const filderlabel = option.label;
    setFilteredValue(fildervalue);
    setFilteredLabel(filderlabel);
    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("MATSUBGROUP_CODE", fildervalue);
    formData.append("FORMNAME", orderType);
    formData.append("CHKFASTMOVING", checkedValue);
    formData.append("ITEMSEARCHSTRING", searchValue);
    formData.append("OFFSET", "0");
    formData.append("NEXT", "20");

    axios.post(BASE_URL + "/getitemcode", formData)
      .then((response) => {
        console.log("Response from API:", response.data);
        setItems(response.data.ITEMCODE);
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
      });
  }

  const handleSearch = (value) => {
    setSearchValue(value);
    const lowerCaseSearchValue = value.toLowerCase();

    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("MATSUBGROUP_CODE", filteredValue);
    formData.append("FORMNAME", orderType);
    formData.append("CHKFASTMOVING", checkedValue);
    formData.append("ITEMSEARCHSTRING", lowerCaseSearchValue);
    formData.append("OFFSET", "0");
    formData.append("NEXT", "20");

    axios.post(BASE_URL + "/getitemcode", formData)
      .then((response) => {
        console.log("Response from API:", response.data);
        setItems(response.data.ITEMCODE);
      })
      .catch((error) => {
        console.error("Error fetching items:", error);
      });

    const filtered = items.filter(item =>
      item.MAT_CODE.toString().includes(value) ||
      item.MUUNITCODE.toString() ||
      item.DESCRIPTION.toLowerCase().includes(value) ||
      item.DESCRIPTION.toUpperCase().includecreateRows(value) ||
      item.DESCRIPTION.includes(value)
    );
    setFilteredItems(filtered);
    console.log('dddd', filteredItems);
  };

  const createRow = (MAT_CODE, DESCRIPTION, qty, unit, price, tax, total, pending_npo, pending_mpo, stock, p_unit, psg, bg, bcs) => {
    const calculatedPrice = qty * unit;
    return { MAT_CODE, DESCRIPTION, qty, unit, price: calculatedPrice, tax, total, pending_npo, pending_mpo, stock, p_unit, psg, bg, bcs };
  };

  const handeltablesubmit = (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('login_id', login_id);
    formData.append('dealer_code', selectedOption.values.DEALER_CODE);
    formData.append('order_type', orderType);
    const itemCodes = [];
    const quantities = [];

    if (Array.isArray(selectedItems) && selectedItems.length > 0) {
      selectedItems.forEach(row => {
        itemCodes.push(row.MAT_CODE);
        quantities.push(row.qty.toString());
      });
      formData.append('item_code', itemCodes);
      formData.append('quantity', quantities);
    } else {
      console.log('No items selected');
    }

    console.log('test ', formData);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: BASE_URL + "/savesalesorderdetails",
      data: formData
    };

    axios.request(config)
      .then((response) => {
        console.log(response.data);
        console.log(JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: 'Item Already Added!',
          text: 'This item is already in the selected items list.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
      });
  };

  const onSearch = (value) => {
    console.log('search:', value);
  };

  const updateQuantity = (code, value) => {
    const updatedRows = selectedItems.map(selectedItems => {
      if (selectedItems.MAT_CODE === code) {
        const newQty = Math.max(selectedItems.qty + value, 0);
        const newPrice = newQty * selectedItems.unit;
        return { ...selectedItems, qty: newQty, price: newPrice };
      }
      return selectedItems;
    });
    setSelectedItems(updatedRows);
  };

  const updateQuantityApicall = (code, value) => {
    const formData = new FormData();
    formData.append("DEALER_CODE", selectedOption.values.DEALER_CODE);
    formData.append("item_code", code);
    formData.append("item_qty", value);

    axios.post(BASE_URL + "/getQtyvalue", formData)
      .then((response) => {
        console.log("Response from API:", response.data);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'warning',
          title: error.response.data.Message,
        });
      });
  }

  const validateGroupedTotals = async (totalsByBGAndUnit, orderType) => {
    try {
      const formattedTotals = Object.entries(totalsByBGAndUnit).flatMap(([bg, units]) =>
        Object.entries(units).map(([unit, total]) => ({
          bg: bg,
          p_unit: unit,
          total: parseFloat(total.toFixed(2))
        }))
      );

      const response = await axios.post(BASE_URL + '/global_billing_total_config', {
        order_type: orderType,
        grouped_totals: formattedTotals,
        branch: branch
      });

      const validationResults = response.data.validation_results || [];

      const errorMessages = validationResults
        .filter(result => result.status_code === "400")
        .map(result => `•${result.message}`);

      if (errorMessages.length > 0) {
        setLoading(false);
        await Swal.fire({
          icon: 'info',
          html: errorMessages.join('<br>'),
          confirmButtonText: 'OK'
        });

        return { status: 'error' };
      }

      return { status: 'success' };
    } catch (error) {
      setLoading(false);
      console.error('Validation failed:', error);
      await Swal.fire({
        icon: 'info',
        text: 'Something went wrong while validating.',
      });
      return { status: 'error' };
    }
  };

  const handleReset = () => {
    setSelectedItems([]);
    setAddedItems([]);
    setAddedItemIds([]);
    setSelectedItem(null);
    setDisableAddItem(false);
    setIsButtonDisabled(false);
  }

  const ccyFormat = (num) => {
    if (typeof num === 'number' && !isNaN(num)) {
      return num.toFixed(2);
    } else {
      return "Invalid input";
    }
  };

  const rowsCount = selectedItems.length;
  const isItemAdded = (item) => {
    return addedItems.includes(item.MAT_CODE);
  };

  const handleDeleteRow = (item) => {
    setSelectedItems(prevItems => prevItems.filter(selectedItem => selectedItem.MAT_CODE !== item.MAT_CODE));
    setAddedItems(prevAddedItems => prevAddedItems.filter(addedItem => addedItem !== item.MAT_CODE));
    const updatedRows = selectedItems.filter(selectedItem => selectedItem.MAT_CODE !== item.MAT_CODE);
    if (updatedRows.length === 0) {
      setSelectedItem(null);
      setAddedItemIds([]);
      setDisableAddItem(false);
    }
  };

  const handleCheckOut = () => {
    setSelectedItems(selectedItems);
  }

  const invoiceSubtotal = selectedItems.reduce((sum, { price }) => sum + price, 0);
  console.log('gopi', invoiceSubtotal);
  const invoiceTaxtotalqty = selectedItems.reduce((sum, row) => {
    const rowTaxQty = row.qty * row.tax;
    return sum + rowTaxQty;
  }, 0);
  const qty = invoiceTaxtotalqty;
  const invoiceTotal = qty + invoiceSubtotal;

  const totalsByBGAndUnit = selectedItems.reduce((acc, item) => {
    const bgKey = item.bg?.toString().trim() || '';
    const unitKey = item.p_unit?.toString().trim() || '';
    const itemTotal = item.unit * item.qty;

    if (!acc[bgKey]) {
      acc[bgKey] = {};
    }

    acc[bgKey][unitKey] = (acc[bgKey][unitKey] || 0) + itemTotal;

    return acc;
  }, {});

  const css = `
    .fixed-header {
      position: sticky;
      top: 0;
      z-index: 1000;
      background-color: white;
    }
   
    .fixed-footer {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
    
    .table-container {
      overflow-y: auto;
      scrollbar-width: none;
    }

    .table-container::-webkit-scrollbar-track {
      background-color: #FFFFFF;
    }
    
    .table-container::-webkit-scrollbar-thumb {
      background-color: #FFFFFF;
    }
    
    .table-container::-webkit-scrollbar-corner {
      background-color: #FFFFFF;
    }
    
    .table-fixed {
      width: 100%;
      table-layout: fixed;
    }
    
    .table-fixedsss th,
    .table-fixedsss td {
      width: 33.3%;
    }
    
    .ant-input {
      background-color: #f5f5f5;
    }
    .quantity-btn {
        margin: 0 2px;
        background-color: #808181;
        color: #ffffff;
        border: none;
        padding: 2px 5px;
        border-radius: 5px;
        cursor: pointer;
      }

      .quantity-btn1 {
        margin: 0 2px;
        background-color: #808181;
        color: #ffffff;
        border: none;
        padding: 2px 5px;
        border-radius: 5px;
        cursor: pointer;
      }
      
      quantity-btn:hover {
        background-color: #dd0707;
      }

      quantity-btn1:hover {
        background-color: #1dbe06;
      }

      .social-icons span{
        margin: 10px;
        font-size: 20px; 
      }
             
    .social-icons span:hover{
        color:red,
    }

    .btn-purple-moon {
        background: #4e54c8;
        background: -webkit-linear-gradient(to right, #8f94fb, #4e54c8);
        background: linear-gradient(to right, #8f94fb, #4e54c8);
        color: #fff;
        border: 2px solid #eee;
    }
    
    .btn-ultra-voilet {
        background: #654ea3;
        background: -webkit-linear-gradient(to right, #eaafc8, #654ea3);
        background: linear-gradient(to right, #eaafc8, #654ea3);
        color: #fff;
        border: 2px solid #eee;
    }
    
    .btn-pink-moon {
        background: #ec008c;
        background: -webkit-linear-gradient(to right, #fc6767, #ec008c);
        background: linear-gradient(to right, #fc6767, #ec008c);
        color: #fff;
        border: 2px solid #eee;
    }

    .btn-pink-moon1 {
        background: #A16BFE;
        background: -webkit-linear-gradient(to right, #DEB0DF, #A16BFE);
        background: linear-gradient(to right, #DEB0DF, #A16BFE);
        color: #fff;
        border: 2px solid #eee;
    }

    .btn-dark-blue {
        background: #7474BF;
        background: -webkit-linear-gradient(to right, #348AC7, #7474BF);
        background: linear-gradient(to right, #348AC7, #7474BF);
        color: #fff;
        border: 1px solid #eee;
    }

    .btn-circle-sm {
        width: 15px;
        height: 15px;
        line-height: 15px;
        font-size: 0.5rem;
      }

      .btn-circle {
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        padding: 0;
      }

      .btn-circle1 {
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        padding: 0;
      }

      .btn-circle: hover{
        color: #fff;
      }

      .dropdown:hover>.dropdown-menu {
        display: block;
      }
      
      .dropdown>.dropdown-toggle:active {
        pointer-events: none;
      }

      .loader-container {
        display: absolute;
        justify-content: center;
        align-items: center;
      }
      
      .custom-uploader .ant-upload {
        padding: 12px;
        border: 2px dashed #d9d9d9;
        border-radius: 8px;
        background-color: #fafafa;
        transition: border-color 0.3s;
      }

      .custom-uploader .ant-upload:hover {
        border-color: #1890ff;
      }

      .uploaded-file-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        background-color: #f5f5f5;
        border-radius: 4px;
      }
      
      .bcs-upload-icon {
        color: #ff4d4f;
        margin-left: 5px;
        cursor: pointer;
      }

      .bcs-doc-status {
        font-size: 12px;
        color: #52c41a;
        margin-left: 5px;
      }
        .uploaded-file-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 8px;
}

.ant-modal-body {
  padding: 0;
}
  `;

  const tableStyle = {
    display: 'block',
    height: '56.5vh',
    maxHeight: '56.5vh',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    width: 'calc(100%)'
  };

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Modal
        title={
          <div className="d-flex align-items-center">
            <FileTextOutlined style={{ fontSize: '24px', color: '#1890ff', marginRight: '10px' }} />
            <span>Upload Documents for BCS Item</span>
          </div>
        }
        open={bcsUploadModalVisible}
        onOk={handleBcsUploadOk}
        onCancel={handleBcsUploadCancel}
        width={800}
        footer={[
          <Button key="proceedWithoutDocs" onClick={handleBcsProceedWithoutDocs}>
            Proceed Without Documents
          </Button>,
          <Button key="cancel" onClick={handleBcsUploadCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleBcsUploadOk}>
            Upload Documents
          </Button>,
        ]}
      >
        {currentBcsItem && (
          <div>
            <p className="mb-3">
              <strong>Item:</strong> {currentBcsItem.MAT_CODE} - {currentBcsItem.DESCRIPTION}
            </p>
            <p className="text-muted mb-4">
              Please upload the required documents for this BCS item.
            </p>

            <Row gutter={16}>
              <Col span={12}>
                {uploadButton(
                  'workOrder',
                  <FileWordOutlined style={{ fontSize: '32px', color: '#1890ff' }} />,
                  'Work Order',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
              <Col span={12}>
                {uploadButton(
                  'technicalDataSheet',
                  <FilePdfOutlined style={{ fontSize: '32px', color: '#ff4d4f' }} />,
                  'Technical Data Sheet',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                {uploadButton(
                  'customerApprovedGAD',
                  <FileTextOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
                  'Customer Approved GAD',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
              <Col span={12}>
                {uploadButton(
                  'customerApprovedQAP',
                  <FileExcelOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
                  'Customer Approved QAP',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                {uploadButton(
                  'drawings',
                  <FileImageOutlined style={{ fontSize: '32px', color: '#faad14' }} />,
                  'Drawings (if any)',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
              <Col span={12}>
                {uploadButton(
                  'otherDocuments',
                  <FileUnknownOutlined style={{ fontSize: '32px', color: '#722ed1' }} />,
                  'Other Documents (if any)',
                  currentBcsItem.MAT_CODE
                )}
              </Col>
            </Row>

            <div className="mt-4 p-3" style={{ backgroundColor: '#f0f8ff', borderRadius: '6px' }}>
              <InfoCircleOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
              <span>
                You can proceed without uploading documents, but they may be required later for processing your order.
                Maximum file size for each document is 2MB.
              </span>
            </div>
          </div>
        )}
      </Modal>
      <Modal
  open={previewVisible}
  title={previewTitle}
  footer={null}
  onCancel={handlePreviewCancel}
  width="80%"
  style={{ top: 20 }}
>
  {previewFile && (
    <div style={{ height: '70vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {previewFile.type.includes('image/') ? (
        <img
          alt="Preview"
          src={URL.createObjectURL(previewFile)}
          style={{ maxWidth: '100%', maxHeight: '100%' }}
        />
      ) : previewFile.type === 'application/pdf' ? (
        <iframe
          src={URL.createObjectURL(previewFile)}
          width="100%"
          height="100%"
          title="PDF Preview"
          style={{ border: 'none' }}
        />
      ) : (
        <div className="text-center">
          <FileUnknownOutlined style={{ fontSize: '64px', color: '#999' }} />
          <p className="mt-3">Preview not available for this file type</p>
          <Button 
            type="primary" 
            href={URL.createObjectURL(previewFile)} 
            download={previewFile.name}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download File
          </Button>
        </div>
      )}
    </div>
  )}
</Modal>

      <Grid container>
        <style>{css}</style>
        <Grid item xs={5} lg={5} style={{ flexGrow: 1, height: 'auto' }} >
          <Paper style={{ padding: '1px' }}>
            <div style={{ backgroundColor: '#f5f5f5' }}>

              <Row md={12} lg={5} style={{ position: 'absolute', backgroundColor: 'white', width: '43%', height: '9%', justifyContent: 'center', alignItems: 'center' }}>
                <Col xs={12} lg={4} md={6} sm={12}>
                  <Search
                    placeholder="Search"
                    onSearch={handleSearch}
                    value={searchValue}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{
                      width: '100%',
                    }}
                  />
                </Col>
                <Col xs={12} lg={6} md={6} sm={12}>
                  <Form>
                    <Form.Group controlId="filterSelect">
                      <Select
                        style={{
                          width: '100%',
                        }}
                        showSearch
                        placeholder="PSG"
                        optionFilterProp="children"
                        onChange={handelFilterChange}
                        onSearch={onSearch}
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: '',
                            label: 'Select Filter',
                          },
                          ...filtered.map(item => ({
                            value: item.PSG_CODE,
                            label: item.PSG_Name,
                          })),
                        ]}
                      />
                    </Form.Group>
                  </Form>
                </Col>
                <Col xs={12} lg={2} md={12} sm={12}>
                  <Form>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label={
                        <div className='row'>
                          <div className='col-auto' style={{ fontWeight: 'bold' }}>FM
                            <a className="dropdown">
                              <FcInfo
                                className="dropdown-toggle"
                                size={20}
                                id="dropdownMenuButton"
                                aria-expanded="false"
                              />
                              <ul className="dropdown-menu" style={{ position: 'absolute', zIndex: '9999' }} aria-labelledby="dropdownMenuButton">
                                <li><a className="dropdown-item">Fast Moving</a></li>
                              </ul>
                            </a>
                          </div>
                        </div>
                      }
                      checked={checked}
                      onChange={handleSwitchChange}
                    />
                  </Form>
                </Col>
              </Row>
              <br />
              <br />
              <div className="table-container mt-2" style={{ height: '84vh', maxHeight: '84vh' }}>
                <table className="table table-fixed">
                  <thead className="fixed-header">
                    <tr>
                      <th className="col-sm-3"><b>Code</b></th>
                      {anyLocationChecked == 1 && (<th className="col-sm-3"><b>P.Unit</b></th>)}
                      <th className="col-sm-7"><b>Description</b></th>
                      <th className="col-sm-2"><b>Action</b></th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <tr>
                      <td colSpan="3" style={{ padding: '0.5rem', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', left: '100vh', height: '70vh' }}>
                          <div className="loader-container">
                            <Loader size="sm" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      <tbody className="h-100 w-100" style={{ height: '100%' }}>
                        {searchValue.length > 0 ? (
                          filteredItems.length > 0 ? (
                            filteredItems.map(item => (
                              <tr key={item.MAT_CODE} className="h-100">
                                <td className="col-sm-3 col-lg-3 col-md-3" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal', maxWidth: '100px' }}>
                                  {item.MAT_CODE}
                                </td>
                                {anyLocationChecked == 1 && <td className="col-sm-1 col-lg-1 col-md-3" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal' }}>
                                  {item.MUUNITCODE}
                                </td>}
                                <td className="col-sm-7 col-lg-7 col-md-3" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal' }}>
                                  {item.DESCRIPTION}
                                </td>
                                <td className="col-sm-1 col-lg-1 col-md-3" style={{ padding: '0.5rem 0.30rem', textAlign: 'right' }}>
                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                      className="btn btn-dark-blue btn-rounded btn-sm"
                                      onClick={() => handleCardClick(item)}
                                      disabled={isItemAdded(item)}
                                      style={{ minWidth: '80px' }}
                                    >
                                      {isItemAdded(item) ? "Added" : "Add"}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" style={{ textAlign: 'center' }}>No data available</td>
                            </tr>
                          )
                        ) : (
                          items.length > 0 ? (
                            items.map(item => (
                              <tr key={item.Itemcode} style={{ whiteSpace: 'normal' }}>
                                <td className="col-sm-3 col-lg-3 col-md-3" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal', maxWidth: '100px' }}>
                                  {item.MAT_CODE}
                                </td>
                                {anyLocationChecked == 1 && <td className="col-sm-1 col-lg-1 col-md-3" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal' }}>
                                  {item.MUUNITCODE}
                                </td>}
                                <td className="col-sm-8 col-lg-8" style={{ padding: '0.5rem 0.30rem', whiteSpace: 'normal' }}>
                                  {item.DESCRIPTION}
                                </td>
                                <td className="col-sm-1 col-lg-1" style={{ padding: '0.5rem 0.30rem', textAlign: 'right' }}>
                                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <button
                                      className="btn btn-dark-blue btn-rounded btn-sm"
                                      onClick={() => handleCardClick(item)}
                                      disabled={isItemAdded(item)}
                                      style={{ minWidth: '80px' }}
                                    >
                                      {isItemAdded(item) ? "Added" : "Add"}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" style={{ textAlign: 'center' }}>No Item Available For <span className="text-Orange"><b>{orderType}</b></span> Order Against <span className="text-info"><b>{filteredLabel.length > 0 ? filteredLabel : filteredLabel == 'Select Filter' ? "All" : "All"}</b></span> PSG</td>
                            </tr>
                          )
                        )}

                      </tbody>
                      <tfoot style={{ padding: '0.5rem' }}>
                        <tr>
                          <td colSpan="3" style={{ padding: '0.5rem', textAlign: 'center' }}>
                            <button className='btn btn-success hide' type='button' onClick={handleViewMore}>View more</button>
                          </td>
                        </tr>
                      </tfoot>
                    </>
                  )}
                </table>
              </div>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={7} lg={7} style={{ overflowY: 'auto', flexGrow: 1, height: 'auto' }}>
          <Paper style={{ padding: '1px' }}>
            <div className='container'>
              <form onSubmit={handeltablesubmit}>
                <div style={{ backgroundColor: '#f5f5f5' }}>

                  <div className='row p-1' style={{ color: 'deeppink' }}>
                    <div className='col-6 float-md-start'>
                      <h6><b>{selectedOption.values.DEALER_CODE}-{selectedOption.values.DEALERNAME} <a className="dropdown">
                        <FcInfo
                          className="dropdown-toggle"
                          size={20}
                          id="dropdownMenuButton"
                          aria-expanded="false"
                        />
                        <ul className="dropdown-menu" style={{ position: 'absolute', zIndex: '9999' }} aria-labelledby="dropdownMenuButton">
                          {Object.entries(realTimeinfo).slice(1, 4).map(([key, value], index) => {
                            const formattedKey = key.replace(/_/g, ' ').toUpperCase() === "CLOSING BALANCE" ? "AVAILABLE BALANCE" : key.replace(/_/g, ' ').toUpperCase();
                            const formattedValue = typeof value ? new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) : value;
                            return (
                              <div key={index}>
                                <li>
                                  <a className="dropdown-item">{`${formattedKey}: ${formattedValue}`}</a>
                                </li>
                              </div>
                            );
                          })}
                        </ul>
                      </a></b></h6>
                    </div>
                    <div className='col-3'>
                      <h6
                        style={{
                          backgroundColor: anyLocationChecked === 1 ? '#FF007F' : 'transparent',
                          color: anyLocationChecked === 1 ? '#fff' : 'inherit',
                          fontWeight: 'bold',
                          padding: '0.5rem',
                          borderRadius: '6px',
                          textAlign: 'center',
                          boxShadow: anyLocationChecked === 1 ? '0 2px 6px rgba(255, 0, 127, 0.5)' : 'none',
                        }}
                      >
                        {anyLocationChecked === 1 && 'GLOBAL ORDER'}
                      </h6>
                    </div>

                    <div className='col-3'>
                      <div className='float-end' align='left' style={{ width: '20%' }}>
                        <h6 className='' style={{ alignItems: 'end' }}><b>{orderType}</b></h6>
                      </div>
                    </div>
                  </div>
                  {selectedItems.length > 0 ? (
                    <div>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ backgroundColor: 'white', display: 'table', width: '100%' }}>
                          <tr style={{ display: 'flex', width: '100' }}>
                            <th style={{ flex: '1 1 55%', padding: '0.50rem 0.30rem', textAlign: 'left' }}><h6><b>Item Details</b></h6></th>
                            <th style={{ flex: '1 1 12%', padding: '0.50rem 0.30rem', textAlign: 'left' }}><h6><b>Price</b></h6></th>
                            <th style={{ flex: '1 1 15%', padding: '0.50rem 0.30rem', textAlign: 'left' }}><h6><b>Quantity</b></h6></th>
                            <th style={{ flex: '1 1 12%', padding: '0.50rem 0.30rem', textAlign: 'left' }}><h6><b>Value</b></h6></th>
                            {anyLocationChecked == 1 && <th style={{ flex: '1 1 12%', padding: '0.50rem 0.30rem', textAlign: 'left' }}><h6><b>P.Unit</b></h6></th>}
                            <th style={{ flex: '1 1 13%', padding: '0.50rem 0.30rem', textAlign: 'right' }}><h6><b>Action</b></h6></th>
                          </tr>
                        </thead>
                        <tbody style={{ display: 'table', width: '100%', ...tableStyle }}>
                          {selectedItems.map((item) => (
                            <tr key={item.MAT_CODE}>
                              <td style={{ width: '55%', padding: '0.50rem 0.30rem', }}>
                                <div className='row'>
                                  <div>
                                    <span style={{ color: '#376ce7', fontWeight: 'bold' }}>{item.MAT_CODE}</span>
                                    {item.bcs && item.bcs.toLowerCase() === 'bcs' && (
                                      <>
                                        <FileTextOutlined 
                                          className="bcs-upload-icon" 
                                          onClick={() => handleBcsUploadClick(item)}
                                          title="Upload BCS Documents"
                                        />
                                        {bcsItemsWithDocs[item.MAT_CODE] && (
                                          <span className="bcs-doc-status" title="Documents uploaded">
                                            ✓
                                          </span>
                                        )}
                                      </>
                                    )}
                                    - {item.DESCRIPTION}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: '12%', padding: '0.50rem 0.30rem', textAlign: 'right' }}>
                                <div className='row'>
                                  <div>{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(item.unit)}</div>
                                </div>
                              </td>
                              <td style={{ width: '12%', padding: '0.50rem 0.30rem', textAlign: 'center' }}>
                                <div className='row'>
                                  <div>
                                    <input
                                      type="number"
                                      step="any"
                                      style={{ width: '70px', textAlign: 'right' }}
                                      value={item.qty === 0 ? '' : item.qty}
                                      onChange={(e) => {
                                        let inputValue = e.target.value.trim();
                                        inputValue = inputValue.replace(/[^0-9.]/g, '');
                                        const parts = inputValue.split('.');
                                        if (parts.length > 2) {
                                          inputValue = parts[0] + '.' + parts.slice(1).join('');
                                        }
                                        if (inputValue.length > 8) {
                                          inputValue = inputValue.slice(0, 8);
                                        }
                                        if (inputValue === '') {
                                          updateQuantity(item.MAT_CODE, -item.qty);
                                        } else {
                                          if (/^\d*\.?\d*$/.test(inputValue)) {
                                            let newQty = parseFloat(inputValue);
                                            if (!isNaN(newQty) && newQty >= 0) {
                                              updateQuantity(item.MAT_CODE, newQty - item.qty);
                                            }
                                          }
                                        }
                                        e.target.value = inputValue;
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: '15%', padding: '0.50rem 0.30rem', textAlign: 'right' }}>
                                <div className='row'>
                                  <div>{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(ccyFormat(item.price))}</div>
                                </div>
                              </td>
                              {anyLocationChecked == 1 && <td style={{ width: '12%', padding: '0.50rem 0.30rem', textAlign: 'right' }}>
                                <div className='row'>
                                  <div>{item.p_unit}</div>
                                </div>
                              </td>}
                              <td style={{ width: '12%', padding: '0.50rem 0.30rem', textAlign: 'center' }}>
                                <div className='d-flex justify-content-around'>
                                  <div className='p-1 d-inline-flex'>
                                    <div className="dropdown btn-circle1">
                                      <FcInfo
                                        className="dropdown-toggle"
                                        size={20}
                                        id="dropdownMenuButton"
                                        aria-expanded="false"
                                        data-placement="left"
                                        title={`More info for ${item.MAT_CODE}`}
                                      />
                                      <ul id="dropdownContent" className="dropdown-menu" style={{ position: 'absolute', zIndex: '9999', left: '-130px', top: '25px' }} aria-labelledby="dropdownMenuButton">
                                        <li><a className="dropdown-item">PENDING NPO: {item.pending_npo}</a></li>
                                        <li><a className="dropdown-item">PENDING MPO: {item.pending_mpo}</a></li>
                                        <li><a className="dropdown-item">STOCK: {item.stock}</a></li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className='p-1 d-inline-flex'>
                                    <button type="button" className="btn btn-danger btn-circle btn-circle-sm btn-sm m-1 ml-1" style={{ position: 'relative' }} onClick={() => handleDeleteRow(item)}>
                                      <DeleteIcon color='#b80000' />
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div style={{ backgroundColor: '#f5f5f5', height: '100%' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(60.5vh)' }}>
                        <center><BsCart4 size={100} /><h4>No Item Order</h4></center>
                      </div>
                    </div>
                  )}
                </div>
                <div className='row'>
                  <div className='col-6'>
                    <div className='row'>
                      <div className='d-flex align-items-end'><h6><b>Total Items: {rowsCount}</b></h6> </div>
                    </div>
                    <div className='row mt-2'>
                      <div className='col-12'>
                        <div
                          className='p-2'
                          style={{
                            backgroundColor: '#ffffff',
                            maxHeight: '80px',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            margin: '0 auto'
                          }}
                        >
                          {anyLocationChecked === 1 &&
                            Object.entries(totalsByBGAndUnit).map(([bg, units]) => {
                              const tooltipContent = (
                                <div style={{ color: '#000000' }}>
                                  {Object.entries(units).map(([unit, total]) => (
                                    <div key={unit} style={{ fontSize: '13px' }}>
                                      <strong>{unit}</strong>:{" "}
                                      {new Intl.NumberFormat('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      }).format(total)}
                                    </div>
                                  ))}
                                </div>
                              );

                              return (
                                <div key={bg} style={{ marginBottom: '0.5rem' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <h6 style={{ fontWeight: '600', fontSize: '14px', marginBottom: '0.3rem' }}>
                                      {bg}
                                    </h6>
                                    <Tooltip
                                      title={tooltipContent}
                                      placement="right"
                                      overlayInnerStyle={{
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '6px'
                                      }}
                                      overlayStyle={{ maxWidth: 250 }}
                                    >
                                      <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '16px', cursor: 'pointer' }} />
                                    </Tooltip>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className='col-6'>
                    <table className="table table-fixedsss table-responsive table-sm" style={{ fontSize: '16px', position: 'absolute', bottom: 0, marginBottom: '5px', width: 'auto', display: 'contents', height: '20%' }}>
                      <tbody >
                        <tr>
                          <td colSpan={2} style={{ lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}><b>Subtotal</b></td>
                          <td colSpan={4} style={{ textAlign: 'right', lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}>{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(ccyFormat(invoiceSubtotal))}</td>
                        </tr>
                        <tr>
                          <td style={{ lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}><b>Tax</b></td>
                          <td colSpan={3} style={{ lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}></td>
                          <td style={{ textAlign: 'right', lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}></td>
                          <td style={{ textAlign: 'right', lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}>{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(ccyFormat(qty))}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} style={{ lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}><b>Total</b></td>
                          <td colSpan={4} style={{ textAlign: 'right', lineHeight: '1', padding: '0.50rem 0.30rem 0.50rem 0.25rem' }}>{new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(ccyFormat(invoiceTotal))}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row'>
                  <div class="btn-group btn-group-lg btn-group-sm" role="group">
                    <button type="button" class="btn btn-danger btn-pink-moon1" onClick={onPrev}><IoArrowBackCircle size={30} />Previous</button>
                    <button type="reset" class="btn btn-primary btn-purple-moon" onClick={handleReset}><FcCancel size={30} color='danger' /><span style={{ color: 'danger' }}>Cancel</span></button>
                    <button type="button" class="btn btn-danger btn-pink-moon" disabled={isButtonDisabled} onClick={handleNext}><TiTick size={30} color='white' /><span style={{ color: 'white' }}>Checkout</span></button>
                  </div>
                </div>
              </form>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Order3;